export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11606.b99c3a35.jpg";